<div class="apps-conversion-container">
    <mat-card class="content-card">
        <mat-card-content>

            <!-- Card Header -->
            <div class="card-header">
                <h2 class="page-title">Apps Conversion</h2>

                <mat-form-field appearance="outline" subscriptSizing="dynamic" class="date-range-field">
                    <mat-label>Date Range</mat-label>
                    <mat-date-range-input [formGroup]="dateRange" [rangePicker]="rangePicker">
                        <input matStartDate formControlName="start" placeholder="Start date" readonly>
                        <input matEndDate formControlName="end" placeholder="End date" readonly
                               (dateChange)="onRangeChange()">
                    </mat-date-range-input>
                    <mat-datepicker-toggle matIconSuffix [for]="rangePicker"></mat-datepicker-toggle>
                    <mat-date-range-picker #rangePicker></mat-date-range-picker>
                </mat-form-field>
            </div>

            <div class="table-wrapper">
                <!-- Loading overlay -->
                <div class="loading-overlay" *ngIf="isLoading">
                    <mat-spinner diameter="48"></mat-spinner>
                </div>

                <table mat-table [dataSource]="dataSource" matSort matSortActive="agent" matSortDirection="asc"
                       class="flat-table">

                    <ng-container matColumnDef="agent">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Agent</th>
                        <td mat-cell *matCellDef="let row">{{ row.agent }}</td>
                    </ng-container>

                    <ng-container matColumnDef="appsCreated">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Apps Created</th>
                        <td mat-cell *matCellDef="let row">{{ row.appsCreated }}</td>
                    </ng-container>

                    <ng-container matColumnDef="appsConverted">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Apps Converted</th>
                        <td mat-cell *matCellDef="let row">{{ row.appsConverted }}</td>
                    </ng-container>

                    <ng-container matColumnDef="convertedNotCreated">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Converted Not Created</th>
                        <td mat-cell *matCellDef="let row">{{ row.convertedNotCreated }}</td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell no-data" [attr.colspan]="displayedColumns.length">No data</td>
                    </tr>
                </table>
            </div>

        </mat-card-content>
    </mat-card>
</div>
